export class WordRefModel implements IWord{
    id:string
    text:string
    get displayText():string{
        return this.text;
    }

}


export interface IWord{
    id:string
    get displayText():string
}